import { render, staticRenderFns } from "./Schematic-Tile.vue?vue&type=template&id=071166a9&scoped=true&"
import script from "./Schematic-Tile.vue?vue&type=script&lang=js&"
export * from "./Schematic-Tile.vue?vue&type=script&lang=js&"
import style0 from "./Schematic-Tile.vue?vue&type=style&index=0&id=071166a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071166a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCard,VCardText,VCheckbox})
